import { c as _c } from "react/compiler-runtime";
import { Trash2 } from "lucide-react";
import { useIntl } from "react-intl";
import { TypoTextBold } from "ui/Typo";
import { Button } from "uiShadcn/button";
interface FieldHeaderProps {
  index: number;
  showRemoveButton: boolean;
  onRemoveClick: () => void;
}
export default function FieldHeader(t0) {
  const $ = _c(13);
  const {
    index,
    showRemoveButton,
    onRemoveClick
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const t1 = index + 1;
  let t2;
  if ($[0] !== formatMessage) {
    t2 = formatMessage({
      id: "language"
    });
    $[0] = formatMessage;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <TypoTextBold>{t1}. {t2}</TypoTextBold>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== formatMessage || $[6] !== index || $[7] !== onRemoveClick || $[8] !== showRemoveButton) {
    t4 = showRemoveButton && <Button type="button" dataTestId={`RemoveLang-${index}`} onClick={onRemoveClick} variant="ghost" size="icon" aria-label={formatMessage({
      id: "deleteItem"
    })}><Trash2 size={18} /></Button>;
    $[5] = formatMessage;
    $[6] = index;
    $[7] = onRemoveClick;
    $[8] = showRemoveButton;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className="flex items-center justify-between">{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}